import { ForcedChoiceQuestion, ScaleQuestion } from '../types/assessment'

export const FORCED_CHOICE_QUESTIONS: ForcedChoiceQuestion[] = [
  {
    id: 1,
    text: 'After a tough loss, I usually…',
    optionA: 'Move on quickly and focus on the next challenge',
    optionB: 'Replay it in my head for days to see what went wrong',
  },
  {
    id: 2,
    text: 'When I meet new people…',
    optionA: 'I enjoy starting the conversation',
    optionB: 'I wait until they approach me',
  },
  {
    id: 3,
    text: "If a plan isn't working…",
    optionA: 'I stick with it and finish what I started',
    optionB: 'I switch things up and try something new',
  },
  {
    id: 4,
    text: "I'd rather be known as…",
    optionA: 'The most competitive person on the team',
    optionB: 'The most reliable person on the team',
  },
  {
    id: 5,
    text: "When I've failed at something big…",
    optionA: 'It fires me up to prove myself next time',
    optionB: 'I take it as a sign I should back off',
  },
  {
    id: 6,
    text: 'In a group project…',
    optionA: 'I naturally take the lead',
    optionB: "I'm happiest supporting the leader",
  },
  {
    id: 7,
    text: "If I'm not sure of an answer…",
    optionA: 'I ask questions and figure it out',
    optionB: 'I wait until I know for sure before acting',
  },
  {
    id: 8,
    text: 'I perform best when…',
    optionA: "There's a scoreboard or clear numbers to beat",
    optionB: "There's steady progress and routines to follow",
  },
  {
    id: 9,
    text: 'On a team, I prefer…',
    optionA: 'Constant challenge and competition',
    optionB: 'A supportive environment where things run smoothly',
  },
  {
    id: 10,
    text: 'When practicing a skill…',
    optionA: "I'm fine repeating it until I nail it",
    optionB: 'I get restless and want to move on quickly',
  },
]

export const SCALE_QUESTIONS: ScaleQuestion[] = [
  // SECTION A – DRIVE / GRIT / COMPETITIVENESS
  {
    id: 1,
    text: 'When I lose or fall short, I usually bounce back quickly and try again.',
    category: 'drive',
  },
  {
    id: 2,
    text: 'Competing with others motivates me to perform at my best.',
    category: 'drive',
  },
  {
    id: 3,
    text: "I don't let rejection or criticism stop me from pushing forward.",
    category: 'drive',
  },
  {
    id: 4,
    text: 'I like setting ambitious goals for myself and going after them.',
    category: 'drive',
  },
  {
    id: 5,
    text: 'I find ways to stay energized and focused, even on tough days.',
    category: 'drive',
  },

  // SECTION B – DOMINANCE / INFLUENCE
  {
    id: 6,
    text: "I enjoy starting conversations with people I don't know.",
    category: 'di',
  },
  {
    id: 7,
    text: 'I feel confident speaking up and taking charge in group situations.',
    category: 'di',
  },
  {
    id: 8,
    text: 'I like persuading others to see things from my perspective.',
    category: 'di',
  },
  {
    id: 9,
    text: 'I make decisions quickly, even with limited information.',
    category: 'di',
  },
  {
    id: 10,
    text: "I'd rather take action fast than spend too long planning.",
    category: 'di',
  },

  // SECTION C – STEADINESS / CONSCIENTIOUSNESS
  {
    id: 11,
    text: 'I prefer working from a clear plan or system instead of improvising.',
    category: 'sc',
  },
  {
    id: 12,
    text: "I pay close attention to details so I don't make mistakes.",
    category: 'sc',
  },
  {
    id: 13,
    text: "I'm dependable — if I say I'll do something, people know it will get done.",
    category: 'sc',
  },
  {
    id: 14,
    text: 'I like steady routines and sticking with commitments.',
    category: 'sc',
  },
  {
    id: 15,
    text: "I'd rather follow proven steps than take big risks without a plan.",
    category: 'sc',
  },
]
